import React, { FC } from 'react';
import { LoadingSpinner } from '../icons/OurIcons';
import { Button } from 'primereact/button';
import { ChevronRightIcon, ChevronLeftIcon } from '@heroicons/react/20/solid';
export interface DMPropertyIncrementorProps {
  index: number;
  totalPropertyRecordsFiltered: number;
  loadingProperties: boolean;
  onIncrementorClick: (incrementValue: number) => void; // New prop to accept the increment function from the parent
}

const DMPropertyIncrementor: FC<DMPropertyIncrementorProps> = ({
  index,
  totalPropertyRecordsFiltered,
  loadingProperties,
  onIncrementorClick
}) => {
  const isNextDisabled = () => {
    return index === totalPropertyRecordsFiltered - 1; // Disable if it's the last property
  };

  const isPrevDisabled = () => {
    return index === 0; // Disable if it's the first property
  };

  if (totalPropertyRecordsFiltered <= 0) {
    return (
      <div id='DMPropertyIncrementor-no-properties-found' className="flex justify-center w-full text-sm px-2">
        <p>No properties found</p>
      </div>
    );
  }

  return (
    <div id='DMPropertyIncrementor' className='flex justify-center items-center w-full space-x-4'>
      <Button
        id='DMPropertyIncrementor-prev-btn'
        className={`p-button p-component p-button-text rounded-full p-2 transition-all duration-200
        ${isPrevDisabled()
      ? 'opacity-50 cursor-not-allowed'
      : 'hover:bg-gray-200 hover:shadow-md'}`}
        onClick={(e) => {
          e.currentTarget.blur(); // Remove focus from the button
          onIncrementorClick(-1);
        }}
        disabled={isPrevDisabled()}
      >
        <ChevronLeftIcon className='w-6 h-6' />
      </Button>

      {loadingProperties ? <LoadingSpinner /> : (
        <div className="text-sm px-4 font-medium">
      Property {index + 1} of {totalPropertyRecordsFiltered}
        </div>
      )}

      <Button
        id='DMPropertyIncrementor-next-btn'
        className={`p-button p-component p-button-text rounded-full p-2 transition-all duration-200
      ${isNextDisabled()
      ? 'opacity-50 cursor-not-allowed'
      : 'hover:bg-gray-200 hover:shadow-md'}`}
        onClick={(e) => {
          e.currentTarget.blur(); // Remove focus from the button
          onIncrementorClick(1);
        }}
        disabled={isNextDisabled()}
      >
        <ChevronRightIcon className='w-6 h-6' />
      </Button>
    </div>
  );
};

export default DMPropertyIncrementor;
